const Char = {
  Ash: 'æ',
  Hash: '#'
}

const Encoded = {
  Ash: encodeURIComponent('æ')
}

export class ParamExtractor {
  params = new URLSearchParams()

  /**
   * @param {string} hash the hash string, with or without leading '#'.
   * @returns {string} the cleaned hash string.
   */
  extractHash(hash) {
    hash = hash.startsWith(Char.Hash) ? hash.substring(1) : hash
    const i = hash.indexOf(Encoded.Ash)
    if (i === -1) {
      return hash
    }

    const params = new URLSearchParams(hash.slice(i))
    this.extract(params)
    return hash.slice(0, i)
  }

  /**
   * @param {string} query the query string.
   * @returns {string} the cleaned query string.
   */
  extractQuery(query) {
    const params = new URLSearchParams(query)
    this.extract(params)
    return params.toString()
  }

  /**
   * Extracts æ-prefixed params into this instance,
   * then deletes them from the supplied searchparams
   * object.
   *
   * @param {URLSearchParams} params
   */
  extract(params) {
    const keys = Array.from(params.keys())
    for (const key of keys) {
      if (key.startsWith(Char.Ash)) {
        this.params.set(key.substring(1), params.get(key) ?? '')
        params.delete(key)
      }
    }
  }

  getParams() {
    return this.params
  }
}
